const $ = require('jquery');
const _ = require('underscore');
const url = require('app/url');

const initCalcWidgets = function initCalcWidgets() {
	$(function() {
		function strToNumber(value, defaultVal) {
			var valueType = typeof value,
				parsedValue;

			if (valueType === 'string') {
				parsedValue = parseFloat(value);

				/* should probably fix at some point because parsedValue = parseFloat(value); should always return a value. */
				return parsedValue !== undefined ? parsedValue : defaultVal;
			} else if (valueType === 'number') {
				return value;
			} else {
				return defaultVal;
			}
		}

		var WidgetFunctions = {
			BathFanCalc: {
				calculate: function($widget) {
					var $w = $widget,
						$sqft = $w.find('input.input_sqft'),
						$width = $w.find('input.input_width'),
						$length = $w.find('input.input_length'),
						$height = $w.find('input.input_height'),
						roomHeight = strToNumber($height.val(), 10),
						roomWidth = strToNumber($width.val(), 0),
						roomLength = strToNumber($length.val(), 0),
						sqft = roomWidth * roomLength || strToNumber($sqft.val(), 0),
						suggestedCFM = null;

					if (sqft) {
						suggestedCFM = (sqft * roomHeight) / 7.5;
					}

					return suggestedCFM;
				},
				setRecommendation: function(e) {
					var $w = $(e.target).closest('.bathfan_calc_widget'),
						cfm = this.calculate($w),
						$resultContainer = $w.find('.result_container'),
						$result = $w.find('.cfm_result');

					if (cfm) {
						$resultContainer.show().removeClass('hide');

						$result.html(`${Math.ceil(cfm)} CFM`);
					} else {
						$result.html('');
					}
				},
				selectFacet: function(e) {
					var $w, cfm, offset, range, cfmFacet, facetId, params;
					$w = $(e.target).closest('.bathfan_calc_widget');
					cfm = this.calculate($w);
					offset = cfm / 10;
					range = {
						min: Math.floor(Math.max(0, cfm - offset)),
						max: Math.ceil(Math.max(0, cfm + offset))
					};

					// Find the facet
					cfmFacet = _.find(window.dataLayer.facets, function(facet) {
						return facet.id && facet.id === 'cfm-slider';
					});

					// If the facet is found  then find the facetid
					if (cfmFacet && cfmFacet.resultValues && cfmFacet.resultValues[0]) {
						facetId = cfmFacet.resultValues[0].facetId;
					}

					// If we have a facetId then update the url to apply the filter.
					if (facetId) {
						params = url.deserializeParameters();
						url.removeParameterByKey(params, `f${facetId}`);
						params[`f${facetId}`] = [range.min, range.max];
						window.location.search = url.serializeParameters(params);
					}
				},
				load: function() {
					$(document)
						.on('blur keyup', '.bathfan_calc_widget input.calc_input', this.setRecommendation.bind(this))
						.on('click', '.bathfan_calc_widget .calculate', this.setRecommendation.bind(this))
						.on('click', '.bathfan_calc_widget .select_facet', this.selectFacet.bind(this));
					this.cfmFacets = $('.js-group-cfm-slider');
					if (this.cfmFacets.length) {
						$('.bathfan_calc_widget .select_facet')
							.show()
							.removeClass('hide');
					}
				}
			},
			ACCalc: {
				calculate: function($widget) {
					var $w = $widget,
						$sqft = $w.find('input.input_sqft'),
						sqft = strToNumber($sqft.val(), 0);

					return sqft;
				},
				setRecommendation: function(e) {
					var $w = $(e.target).closest('.ac_calc_widget'),
						sqft = Math.round(this.calculate($w) / 10) * 10,
						$resultContainer = $w.find('.result_container'),
						$resultButton = $resultContainer.children('button');

					if (sqft) {
						$resultButton.prop('disabled', false);
						$resultButton.removeClass('disabled-button');
					} else {
						$resultButton.prop('disabled', true);
						$resultButton.addClass('disabled-button');
					}
				},
				selectFacet: function(e) {
					var $w, sqft, facetId, offset, range;
					$w = $(e.target).closest('.ac_calc_widget');
					sqft = Math.round(10 * this.calculate($w)) / 10;
					offset = 100;
					range = {
						min: Math.floor(Math.max(0, sqft - offset)),
						max: Math.ceil(Math.max(0, sqft + offset))
					};
					facetId = this.coolingAreaFacets.find('[data-facetid]').data('facetid');

					window.updateSliderById(facetId, range.min, range.max);
				},
				load: function() {
					$(document)
						.on('blur keyup', '.ac_calc_widget input.calc_input', this.setRecommendation.bind(this))
						.on('click', '.ac_calc_widget .calculate', this.setRecommendation.bind(this))
						.on('click', '.ac_calc_widget .select_facet', this.selectFacet.bind(this));
					this.coolingAreaFacets = $('.facet-group-cooling-area-slider');
					if (this.coolingAreaFacets.length) {
						$('.ac_calc_widget .select_facet')
							.show()
							.removeClass('hide');
						$('.ac_calc_widget')
							.find('.result_container')
							.children('button')
							.prop('disabled', true);
					}
				}
			},
			LightingCalc: {
				calculate: function($widget) {
					var $w = $widget,
						$sqft = $w.find('input.input_sqft'),
						$width = $w.find('input.input_width'),
						$length = $w.find('input.input_length'),
						roomWidth = strToNumber($width.val(), 0),
						roomLength = strToNumber($length.val(), 0),
						sqft = roomWidth * roomLength || strToNumber($sqft.val(), 0),
						suggestedWattage = null;

					if (sqft) {
						suggestedWattage = sqft * 1.5;
					}

					return suggestedWattage;
				},
				setRecommendation: function(e) {
					var $w = $(e.target).closest('.lighting_calc_widget'),
						wattage = this.calculate($w),
						$resultsContainer = $w.find('.result_container'),
						$result = $w.find('.wattage_result');

					if (wattage) {
						$resultsContainer.removeClass('hide');
						$result.html(`${Math.ceil(wattage)} Watts`);
					} else {
						$result.html('');
					}
				},
				selectFacet: function(e) {
					var $w = $(e.target).closest('.lighting_calc_widget'),
						wattage = this.calculate($w),
						offset = wattage / 10,
						range = [Math.floor(Math.max(0, wattage - offset)), Math.ceil(Math.max(0, wattage + offset))];

					_.invoke(this.wattageFacets, 'setValue', range, true);
				},
				load: function() {
					$(document)
						.on('blur keyup', '.lighting_calc_widget input.calc_input', this.setRecommendation.bind(this))
						.on('click', '.lighting_calc_widget .calculate', this.setRecommendation.bind(this))
						.on('click', '.lighting_calc_widget .select_facet', this.selectFacet.bind(this));

					// If the FacetManager isn't null, get the Facet
					this.wattageFacets = window.FacetManager
						? window.FacetManager.getFacetsByName(['Wattage_numeric', 'Watts_numeric'])
						: null;

					if (this.wattageFacets) {
						$('.lighting_calc_widget .select_facet')
							.show()
							.removeClass('hide');
					}
				}
			},
			FlooringBudgetingCalc: {
				calculate: function($widget) {
					var $w = $widget,
						$sqft = $w.find('input.input_sqft'),
						$width = $w.find('input.input_width'),
						$length = $w.find('input.input_length'),
						$budget = $w.find('input.input_budget'),
						roomWidth = strToNumber($width.val(), 0),
						roomLength = strToNumber($length.val(), 0),
						sqft = roomWidth * roomLength || strToNumber($sqft.val(), 0),
						budget = strToNumber($budget.val(), 0),
						wastage = 0.1,
						maxCost = null;

					if (budget && sqft) {
						maxCost = (budget / (sqft * (1 + wastage))).toFixed(2);
					}

					return maxCost;
				},
				setRecommendation: function(e) {
					var $w = $(e.target).closest('.flooring_budget_calc_widget'),
						budget = this.calculate($w),
						$resultsContainer = $w.find('.result_container'),
						$result = $w.find('.floor_price_result');

					if (budget) {
						$resultsContainer.show().removeClass('hide');

						$result.html(`$${budget} / sq. ft.`);
					} else {
						$result.html('');
					}
				},
				selectFacet: function(e) {
					var $w = $(e.target).closest('.flooring_budget_calc_widget'),
						budget = this.calculate($w),
						range = [0, budget];

					_.invoke(this.priceFacets, 'setValue', range, true);
				},
				load: function() {
					$(document)
						.on('blur keyup', '.flooring_budget_calc_widget input.calc_input', this.setRecommendation.bind(this))
						.on('click', '.flooring_budget_calc_widget .calculate', this.setRecommendation.bind(this))
						.on('click', '.flooring_budget_calc_widget .select_facet', this.selectFacet.bind(this));
				}
			}
		};

		Object.keys(WidgetFunctions).forEach((key) => {
			const widget = WidgetFunctions[key];
			widget.load && widget.load();
		});
	});
};

module.exports = initCalcWidgets();
